import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import config from "../../../config/api";
import axiosInstance from "../../../config/axiosConfig";

const BackendUrl = config.backendUrl;

export const acceptOpProject = createAsyncThunk(
  "opProjectAssignAction/accept",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.put(
        `${BackendUrl}/managerProjectRequested/operationaction/accept`,
        payload
      );
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const rejectOpProject = createAsyncThunk(
  "opProjectAssignAction/reject",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.put(
        `${BackendUrl}/managerProjectRequested/operationaction/reject`,
        payload
      );
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const opProjectAssignActionSlice = createSlice({
  name: "opProjectAssignAction",
  initialState: {
    loading: false,
    success: false,
    error: null,
    response: null,
  },
  reducers: {
    resetOpProjectState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.response = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(acceptOpProject.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(acceptOpProject.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.response = action.payload;
      })
      .addCase(acceptOpProject.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      })

      // Reject
      .addCase(rejectOpProject.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(rejectOpProject.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.response = action.payload;
      })
      .addCase(rejectOpProject.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      });
  },
});

export const { resetOpProjectState } = opProjectAssignActionSlice.actions;
export default opProjectAssignActionSlice.reducer;
